/*
 * GLOBAL THEME VARS
 */
var viewport = $(window).width(),
    viewportHeight = $(window).height(),
    sm = 576,
    md = 768,
    lg = 992,
    xl = 1200,
    gl = 1540,
    loader = $(".ajax-load"),
    packagesQtyInit,
    packagesQtyViewMore,
    packagesQtyInitDestiny,
    packagesQtyViewMoreDestiny,
    outletsQtyInit,
    outletsQtyViewMore,
    outletsQtyInitDestiny,
    outletsQtyViewMoreDestiny;